import {
  ChaptersListRequest,
  ChaptersListResponse,
} from '../../../types/chapters'
import { useApiPostQuery } from '../useApi'

export const useChaptersList = (requestData?: { LEVEL: string }) => {
  return useApiPostQuery<ChaptersListResponse>(
    '/chapters/list',
    ['chapterList', requestData],
    requestData,
    true
  )
}
